import { ref } from 'vue'
import { schoolApi } from '@/services/api'

/**
 *
 * @deprecated
 */
export const useInfiniteSchool = ({ values = ref([]), limit = ref(30), page = ref(0), firmId }) => {
  // <b-autocomplete-infity class="w-full" @get-more-data="getMoreResources" :list="resourceAutoComplete.list"
  // :selected="project.contributors" @add-selected="addSalesContributor"
  // @remove-selected="removeSalesContributor"
  // :haveMore="resourceAutoComplete.haveMore && !resourceAutoComplete.loading">
  // <template #custom-list="{ selectItem, list }">
  const list = ref([])
  const haveMore = ref(true)
  const loading = ref(false)
  const select = (selected) => {
    const schoolIndex = values.value.findIndex(school => school._id === selected._id)
    if (schoolIndex > -1)
      return values.value.splice(schoolIndex, 1)
    values.value.push(selected)
  }
  const getMoreData = async (options) => {
    if (options.new) {
      page.value = 0
      haveMore.value = true
    }
    loading.value = true
    const schoolRequest = await schoolApi.filter({ page: page.value, limit: limit.value, display: options.search, firmId }).promise

    loading.value = false
    haveMore.value = schoolRequest.count.currentPage < schoolRequest.count.totalPages
    list.value = options.new ? schoolRequest.docs : [...list.value, ...schoolRequest.docs]
    page.value++
  }

  const remove = (toRemove) => {
    const foundIndex = values.value.findIndex(school => school._id === toRemove._id)
    if (foundIndex === -1)
      return

    values.value.splice(foundIndex, 1)
  }

  return {
    haveMore,
    getMoreData,
    remove,
    select,
    list,
    values,
  }
}

// export const useInfinityJob = ({ search = ref(''), limit = ref(20), page = ref(0), isLoading = ref(false), list = ref([]), jobsSelected = ref([]) }) => {
//   const haveMore = ref(true)
//   const getMoreData = async () => {
//     try {
//       isLoading.value = true

//       const searchRequest = jobApi.filter({ search: search.value, limit: limit.value, page: page.value })
//       const searchResponse = await searchRequest.promise
//       haveMore.value = searchResponse.count.hasNextPage

//       await nextTick() // to be sure have more is updated so the request won't be done again

//       list.value = page.value === 0 ? searchResponse.docs : [...list.value, ...searchResponse.docs]

//       return searchResponse
//     }
//     catch (err) {
//       console.log('err', err)
//     }
//     finally {
//       isLoading.value = false
//     }
//   }

//   return {
//     search,
//     limit,
//     page,
//     haveMore,
//     getMoreData,
//     list,
//     isLoading,
//   }
// }

export const useInfinitySchool = ({ search = ref(''), limit = ref(20), page = ref(0), isLoading = ref(false), list = ref([]), firmId }) => {
  const haveMore = ref(true)
  const getMoreData = async () => {
    try {
      isLoading.value = true
      const searchRequest = schoolApi.filter({ firmId, display: search.value, limit: limit.value, page: page.value })
      const searchResponse = await searchRequest.promise
      haveMore.value = searchResponse.count.hasNextPage
      list.value = page.value === 0 ? searchResponse.docs : [...list.value, ...searchResponse.docs]
      return searchResponse
    }
    catch (err) {
      console.error('useInfinitySchool', err)
    }
    finally {
      isLoading.value = false
    }
  }
  return {
    search,
    limit,
    page,
    haveMore,
    getMoreData,
    list,
    isLoading,
  }
}
